import React from "react";
import { FaQuoteLeft } from "react-icons/fa";

const testimonials = [
  {
    id: 1,
    name: "Przemyslaw Grzeszczak",
    role: "Team Leader - Senior Fullstack Developer, Apptension",
    quote:
      "I worked with Junaid for almost a year, and it was a true pleasure. I can highly recommend him! He consistently demonstrated commitment to personal growth. His strong problem-solving skills and ability to think strategically helped a lot during the project.",
  },
  {
    id: 2,
    name: "Helene Follesdal",
    role: "OKR Consultant, Dressage Trainer",
    quote:
      "I was honored to work with Junaid at Futureworks while he was on the tech team and I was on the commercial side. I am sad to lose him as a cheerful colleague! I found him to be always positive and to see the good in situations, to have ideas for solutions whenever challenges came up, and to be very helpful and cooperative with his colleagues. He has been a great asset to Futureworks and lucky are those who get to work with him in the future!",
  },
  {
    id: 3,
    name: "Martin Gawlyta",
    role: "Full Stack Developer",
    quote:
      "I had this huge pleasure to work desk by desk with Junaid. He is a lovely human with passion for hard work and extensive knowledge within backend and front-end, especially with React. He is always happy to help and no doubt will be an important part of every team.",
  },
  {
    id: 4,
    name: "Jeanette Carter",
    role: "CXO | Technology Enthusiast",
    quote:
      "I enjoyed working with Junaid at Futureworks where he did an excellent job! He is our top employee hitting his OKR Weekly Goals - so impressed by his work structure! He is ambitious, hardworking, and solution-oriented - and the best colleague you can ever get. Going to miss his smiling face lots! To his future workplace: please take good care of this great colleague and friend.",
  },
  {
    id: 5,
    name: "Tobias Barsnes",
    role: "Developer",
    quote:
      "I worked with Junaid in Futureworks for almost 2 years. He is a hard worker that strives to learn new things and overcome challenges that meet him. A lot of times he has amazed me at how quickly he can finish things, and still be able to explain the code to his peers. I'd recommend Junaid to anyone looking for a fast learner, executioner and great colleague.",
  },
  {
    id: 6,
    name: "Manuel Leon",
    role: "Founder, Brainiacs",
    quote:
      "I wholeheartedly recommend Junaid as a Full Stack Developer. In the time we worked together, Junaid consistently demonstrated exceptional technical skills, adaptability, and a strong team-player attitude. Their proficiency in JavaScript, React, Node.js, and database management made them an invaluable asset to our team. Junaid's dedication and passion for coding set them apart and will undoubtedly lead to success in any future endeavors.",
  },
];

const Testimonials = () => {
  const getInitials = (name) =>
    name
      .split(" ")
      .map((part) => part[0])
      .join("")
      .slice(0, 2)
      .toUpperCase();

  return (
    <section className="section testimonials" id="testimonials">
      <div className="section-title" data-aos="fade-up">
        <h2>Testimonials</h2>
        <div className="underline"></div>
        <p className="projects-description">
          Feedback from teams and partners I have worked with recently.
        </p>
      </div>

      <div className="testimonials-grid">
        {testimonials.map((item, index) => (
          <article
            key={item.id}
            className="testimonial-card"
            style={{ animationDelay: `${index * 0.12}s` }}
            data-aos="fade-up"
            data-aos-delay={index * 90}
          >
            <div className="testimonial-header">
              <span className="testimonial-avatar">
                {getInitials(item.name)}
              </span>
              <FaQuoteLeft className="testimonial-quote" />
            </div>
            <p className="testimonial-text">{item.quote}</p>
            <div className="testimonial-author">
              <strong>{item.name}</strong>
              <span>{item.role}</span>
            </div>
          </article>
        ))}
      </div>
    </section>
  );
};

export default Testimonials;
